import { createFileRoute, redirect } from '@tanstack/react-router'
import ResetPasswordConfirmPage from '@/views/reset-password-confirm'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute(
  '/auth/reset-password-confirm/$uidb64/$token',
)({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: ResetPasswordConfirmPage,
})
